import './index.scss'
import { waitForGoogleMaps } from '../../../../../map/maploader/maploader';

let ExportOverlay;

waitForGoogleMaps(() => {
  ExportOverlay = class extends google.maps.OverlayView {
    constructor(props) {
      super()
      this.container = document.createElement('div')
      this.dragListener = null
      this.boundsContainer = null
      this.dragLeft = this.dragLeft.bind(this)
      this.dragRight = this.dragRight.bind(this)
      this.dragtop = this.dragTop.bind(this)
      this.dragBottom = this.dragBottom.bind(this)
      this.removeDrag = this.removeDrag.bind(this)
      this.setBounds = props.setBounds
      this.setArea = props.setArea
      this.cancel = props.cancel
    }

    removeDrag() {
      document.removeEventListener('mousemove', this.dragListener)
      this.dragListener = null
    }

    dragLeft(e) {
      e.preventDefault()
      const { x } = e
      if (x > 515) {
        const { offsetLeft, clientWidth } = this.boundsContainer
        this.boundsContainer.style.left = `${offsetLeft + e.movementX}px`
        this.boundsContainer.style.width = `${clientWidth - e.movementX}px`
        this.positionButtons()
      }
    }

    dragRight(e) {
      e.preventDefault()
      const { x } = e
      if (x < window.innerWidth - 15) {
        const { clientWidth } = this.boundsContainer
        this.boundsContainer.style.width = `${clientWidth + e.movementX}px`
        this.positionButtons()
      }
    }

    dragTop(e) {
      e.preventDefault()
      const { y } = e
      if (y > 15) {
        const { offsetTop, clientHeight } = this.boundsContainer
        this.boundsContainer.style.top = `${offsetTop + e.movementY}px`
        this.boundsContainer.style.height = `${clientHeight - e.movementY}px`
        this.positionButtons()
      }
    }

    dragBottom(e) {
      e.preventDefault()
      const { y } = e
      //margin + padding + button row
      if (y < window.innerHeight - 75) {
        const { clientHeight } = this.boundsContainer
        this.boundsContainer.style.height = `${clientHeight + e.movementY}px`
        this.positionButtons()
      }
    }

    positionButtons() {
      const top = this.boundsContainer.offsetTop + this.boundsContainer.offsetHeight + 20,
        left = this.boundsContainer.offsetLeft,
        width = this.boundsContainer.offsetWidth
      this.buttonRow.style.top = `${top}px`
      this.buttonRow.style.left = `${left}px`
      this.buttonRow.style.width = `${width}px`
    }

    updateBounds() {
      const { offsetLeft, offsetTop, offsetHeight, offsetWidth } = this.boundsContainer,
        proj = this.getProjection(),
        ne = proj && proj.fromContainerPixelToLatLng({ y: offsetTop, x: offsetLeft + offsetWidth }),
        sw = proj && proj.fromContainerPixelToLatLng({ y: offsetTop + offsetHeight, x: offsetLeft }),
        bounds = new google.maps.LatLngBounds(sw, ne)
      this.setBounds(bounds)
    }

    onAdd() {
      this.container.className = 'exp-overlay-container'
      const boundsEditor = document.createElement('div'),
        leftBtn = document.createElement('div'),
        rightBtn = document.createElement('div'),
        topBtn = document.createElement('div'),
        bottomBtn = document.createElement('div'),
        buttonRow = document.createElement('div'),
        cancel = document.createElement('button'),
        select = document.createElement('button'),
        help = document.createElement('div')

      buttonRow.className = 'exp-bounds-editor-button-row'
      select.className = 'exp-bounds-editor-select'
      cancel.className = 'exp-bounds-editor-cancel'
      help.className = 'exp-bounds-editor-help'

      cancel.innerText = 'CANCEL'
      select.innerText = 'SELECT AREA'
      select.onclick = this.setArea.bind(this)
      cancel.onclick = this.cancel
      buttonRow.appendChild(help)
      buttonRow.appendChild(select)
      buttonRow.appendChild(cancel)

      leftBtn.className = 'exp-bounds-editor-v-btn exp-bounds-editor-left'
      rightBtn.className = 'exp-bounds-editor-v-btn exp-bounds-editor-right'
      topBtn.className = 'exp-bounds-editor-h-btn exp-bounds-editor-top'
      bottomBtn.className = 'exp-bounds-editor-h-btn exp-bounds-editor-bottom'

      boundsEditor.className = 'exp-bounds-editor'
      boundsEditor.appendChild(leftBtn)
      boundsEditor.appendChild(rightBtn)
      boundsEditor.appendChild(topBtn)
      boundsEditor.appendChild(bottomBtn)
      this.container.appendChild(boundsEditor)
      this.container.appendChild(buttonRow)

      this.boundsContainer = boundsEditor
      this.buttonRow = buttonRow

      this.container.addEventListener('mouseup', (e) => {
        this.updateBounds()
        this.removeDrag()
      })

      leftBtn.addEventListener('mousedown', (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.dragListener = this.dragLeft.bind(this)
        // this.container.addEventListener('mousemove', this.dragListener)
        document.addEventListener('mousemove', this.dragListener);
        document.addEventListener('mouseup', () => {
          document.removeEventListener('mousemove', this.dragListener);
          this.updateBounds();
        });

      })

      rightBtn.addEventListener('mousedown', (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.dragListener = this.dragRight.bind(this)
        // this.container.addEventListener('mousemove', this.dragListener)
        document.addEventListener('mousemove', this.dragListener);
        document.addEventListener('mouseup', () => {
          document.removeEventListener('mousemove', this.dragListener);
          this.updateBounds();
        });

      })

      topBtn.addEventListener('mousedown', (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.dragListener = this.dragTop.bind(this)
        // this.container.addEventListener('mousemove', this.dragListener)
        document.addEventListener('mousemove', this.dragListener);
        document.addEventListener('mouseup', () => {
          document.removeEventListener('mousemove', this.dragListener);
          this.updateBounds();
        });


      })

      bottomBtn.addEventListener('mousedown', (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.dragListener = this.dragBottom.bind(this)
        // this.container.addEventListener('mousemove', this.dragListener)
        document.addEventListener('mousemove', this.dragListener);
        document.addEventListener('mouseup', () => {
          document.removeEventListener('mousemove', this.dragListener);
          this.updateBounds();
        });

      })

      this.getPanes().floatPane.appendChild(this.container)
      ExportOverlay.preventMapHitsAndGesturesFrom(this.container)
    }

    onRemove() {
      this.container.parentElement.removeChild(this.container)
    }

    draw() {
      this.positionButtons()
      this.updateBounds()
    }
  }
})

export default ExportOverlay